import { useState, Fragment, memo } from "react";
import SelectSwiper from './SelectSwiper'
import { useAuthModal } from "core/context";

type TAddRecipeByImageSwiperButton = {
  className?: string,
  children: React.ReactNode
}

const AddRecipeByImageSwiperButton = ({
  className,
  children,
}: TAddRecipeByImageSwiperButton) => {
  const { openModal, token } = useAuthModal();
  const [ isDrawerOpen, setIsDrawerOpen ] = useState<boolean>(false);

  const toggleDrawer = () => {
    if (!token) {
      openModal(() => {
        document.getElementById('AddRecipeByImageSwiperButton')?.click()
      });
      return;
    }
    setIsDrawerOpen((prev: boolean) => !prev);
  }

  return (
    <Fragment>
      <div
        className={className}
        onClick={toggleDrawer}
        id={'AddRecipeByImageSwiperButton'}
      >
        {children}
      </div>
      
      {isDrawerOpen ? <SelectSwiper
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      /> : null}
    </Fragment>
  )
}

export default memo(AddRecipeByImageSwiperButton)
